// extracted by mini-css-extract-plugin
export default {"button":"AddEntityFieldButton_button__FE2Zt","iconContainer":"AddEntityFieldButton_iconContainer__eyqzN"};